import React from 'react';

import {
  useCheckDeletionVerifierQuery,
  useDeleteVerifierMutation,
  VerifiersListDocument,
} from 'src/api';
import { useNotification } from 'src/hooks/app';
import { DeleteConfirmationModal } from 'src/modals/common';
import { ModalV2Props } from 'src/types/modalV2';

type DeleteVerifierConfirmationModalProps = {
  verifierId: string;
};

export const DeleteVerifierConfirmationModal: React.FC<
  ModalV2Props<DeleteVerifierConfirmationModalProps>
> = ({ id, verifierId }) => {
  const { createApolloContext } = useNotification();

  const { data, loading } = useCheckDeletionVerifierQuery({
    variables: { verifierId },
    fetchPolicy: 'network-only',
  });

  const [deleteVerifier, { loading: deleteLoading }] = useDeleteVerifierMutation({
    refetchQueries: [VerifiersListDocument],
    context: createApolloContext({ successMessage: 'Successfully deleted' }),
  });

  const handleConfirm = React.useCallback(
    () => deleteVerifier({ variables: { verifierId } }),
    [deleteVerifier, verifierId],
  );

  return (
    <DeleteConfirmationModal
      id={id}
      entityName="Verifier"
      description="Deleting of the Verifier causes deleting of all connected information like Billing settings, Company information and Approved Verification Purposes list. After deleting Verifier can’t take part in any Verification until they sign up on the platform again."
      check={data?.checkDeletionVerifier}
      loading={loading}
      deleteLoading={deleteLoading}
      onConfirm={handleConfirm}
    />
  );
};
